import { render, staticRenderFns } from "./EmbeddedYoutubeVideo.vue?vue&type=template&id=301afb92&scoped=true&"
import script from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedYoutubeVideo.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedYoutubeVideo.vue?vue&type=style&index=0&id=301afb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301afb92",
  null
  
)

export default component.exports